import React, { useEffect, useState } from "react";
import { usePackages } from "../../../../../hooks/usePackages";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
  CartesianGrid,
  BarChart,
  Bar,
  Cell,
} from "recharts";
import { handleMonth, translate } from "../../../../../utils/Common";
import Spinner from "../../../../../components/Spinner";
import { LuBox } from "react-icons/lu";
import { PiLockersFill } from "react-icons/pi";
import Select from "../../../../../components/common/Select";
import styles from "./Charts.module.css";

const PackagesPickupYearGlobal = (props) => {
  const { yearSelect, canReadFilters = true } = props;
  const { getPickupYear } = usePackages();

  const [data, setData] = useState(null);
  const [typePackage, setTypePackage] = useState(2);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    const signal = new AbortController().signal;
    const result = await getPickupYear(signal, {
      year: Number(yearSelect),
      typePackage: Number(typePackage)
    });
    setIsLoading(false);


    // Validamos si result no esta vacio
    if (result.length > 0) {
      const formattedData = result.map((item) => ({
        month: handleMonth(item?.monthCurrent),
        total: item?.result
      }));

      setData(formattedData);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    if (yearSelect === null) {
      return;
    }

    getData();
  }, [yearSelect, typePackage]);

  const typePackageOptions = [
    { value: "2", label: translate("global.status.typePackage.regular") },
    { value: "3", label: translate("global.status.typePackage.returned") },
  ];

  const chartColors = [
    "var(--color-primary)",
    "var(--color-secondary)",
    "var(--color-primary-dark)",
  ];

  return (
    <div className={styles.chartSection}>
      <div className={styles.chartHeaderRow}>
        <h6 className={styles.chartTitle}>
          {isLoading ? <span><Spinner type={1} /></span> : <LuBox size={20} aria-hidden />}{" "}
          {translate("global.packagesPickupXYear")} -{" "}
          <span className={styles.chartTitleAccent}>{yearSelect}</span>
        </h6>
        {canReadFilters && (
          <div className={styles.filterGroup}>
            <label htmlFor="inputTypePackage" className={styles.filterLabel}>
              <LuBox size={12} /> {translate("global.typeOfPackage")}
            </label>
            <Select
              id="inputTypePackage"
              value={String(typePackage)}
              onChange={(e) => setTypePackage(Number(e.target.value))}
              options={typePackageOptions}
              size="sm"
            />
          </div>
        )}
      </div>

      {yearSelect !== null ? (
        data === null ? null : data.length === 0 ? (
          <div className={styles.noDataCard}>{translate("global.noDataToView")}</div>
        ) : (
          <div className={styles.chartContainerTall}>
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={data} layout="vertical" margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--border-light)" />
                <YAxis type="category" dataKey="month" stroke="var(--text-secondary)" />
                <XAxis type="number" stroke="var(--text-secondary)" />
                <Tooltip labelFormatter={(label) => `${label} ${yearSelect}`} />
                <Legend />
                <Bar dataKey="total" name={translate("global.packages")}>
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={chartColors[index % 3]} />
                  ))}
                  <LabelList dataKey="total" position="right" fill="var(--text-primary)" fontSize={12} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        )
      ) : (
        <div className={styles.noDataCard}>
          <PiLockersFill size={14} aria-hidden /> {translate("global.selectALocker")}
        </div>
      )}
    </div>
  );
};

export default PackagesPickupYearGlobal;
